import React, { useEffect, useState } from "react";
import styled from "styled-components";

import IcoAdd from "@floji-internal/mui-icons/Add";

import { TopicOffnetPersonLinkedIdentityContact } from "--root/static_types/topic.types";
import { ReturnGetTopic } from "--root/static_types/api_methods/methods.query";
import { Strings } from "--root/strings/en";
import { TelephoneNumber } from "--root/utils/TelephoneNumber";
import { SwaggerQueryClient } from "--client/common/apis/rest";
import { IconButton } from "--components/buttons/iconButton";
import { ListEntryText } from "--floponents-web/atoms/ListEntry";
import { StyledTableRow } from "./Table";
import { CloudUserIdentity } from "--root/static_types/shared.types";
import { NotNull } from "--client/../utils";

const SuggestedTableRow = styled(StyledTableRow)`
    border-top: 1px solid ${props => props.theme.palette.ui.border};
    font-size: 0.85em;
`;

export interface SuggestedIdentitiesProps {
    stream: ReturnGetTopic;
    identities: CloudUserIdentity[];
    onLinkedIdentityAdded?: (identity: TopicOffnetPersonLinkedIdentityContact) => void;
}
export const SuggestedIdentities = (props: SuggestedIdentitiesProps) => {
    const [linkedIdentities, setLinkedIdentities] =
        useState<TopicOffnetPersonLinkedIdentityContact[]>()

    // Lookup linked identities and remove any that match existing identities
    useEffect(() => {
        if (props.stream.type.name !== "stream") return;
        SwaggerQueryClient.GetLinkedOffnetIdentities({
            userspaceId: props.stream.type.userspace_id,
            identity: props.identities
        }).then(response => {
            setLinkedIdentities(
                response.filter(identity => (
                    !props.identities.find(existingIdentity => (
                        identity.value === existingIdentity.address
                    ))
                ))
            )
        });
    }, [props.identities, props.stream?.type]);
    const filteredIndentities = React.useMemo(() => linkedIdentities?.map(li => {
        if (li.type === "webchat") return null
        return { ...li, type: li.type }
    }).filter(NotNull),
        [linkedIdentities])
    if (!filteredIndentities?.length) return null;

    return <>
        {filteredIndentities.map(identity => {
            let label: string;
            // eslint-disable-next-line default-case
            switch (identity.type) {
                case "email":
                    label = Strings.offnetControl.suggested_email_address;
                    break;
                case "sip":
                    label = Strings.offnetControl.suggested_phone_number;
                    break;
                case "whatsapp":
                    label = Strings.offnetControl.suggested_whatsapp_number;

                    break;
            }

            const isPhoneIdentity =
                identity.type === "sip" || identity.type === "whatsapp";

            return (
                <SuggestedTableRow key={identity.value}>
                    <ListEntryText
                        primary={isPhoneIdentity
                            ? TelephoneNumber.formatE164Number(identity.value)
                            : identity.value}
                        secondary={label}
                        color="text-disabled"
                    />
                    <IconButton
                        icon={<IcoAdd />}
                        color="positive"
                        size="small"
                        onClick={() => props.onLinkedIdentityAdded?.(identity)}
                    />
                </SuggestedTableRow>
            );
        })}
    </>;
};
